import axios from "../../axios";

const urlForm = "/form-submissions";

const state = {
  submissions: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * getListForms
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListSubmissions({ commit }, query) {
    const response = await axios.get(
      `${urlForm}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_SUBMISSIONS", response.data.data);
    }

    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async delete({ commit }, id) {
    const response = await axios.delete(`${urlForm}/${id}`);

    return response;
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_SUBMISSIONS(state, data) {
    if (data) {
      state.submissions = data.items;
      state.pagination = data.pagination;
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
